import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/company_24px@2x.png'
import _imports_1 from '@/assets/icons/upload_24px.png'


const _withScopeId = n => (_pushScopeId("data-v-3c5c02a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fs-15 fw-700" }
const _hoisted_2 = {
  class: "input-with-icon mt-8",
  style: {"max-width":"46rem"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "icon-20",
    alt: "company_24px@2x"
  })
], -1))
const _hoisted_4 = { class: "fs-15 fw-700 mt-16" }
const _hoisted_5 = { class: "upload-image relative mt-8" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "absolute-mid"
}
const _hoisted_8 = {
  key: 1,
  class: "absolute-mid events-none"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "icons_upload_24px"
  })
], -1))
const _hoisted_10 = { class: "fs-15 fw-700 opa-06 mt-4" }
const _hoisted_11 = {
  key: 2,
  class: "absolute-mid events-none"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "fs-15 fw-700 mt-16" }
const _hoisted_14 = { style: {"max-width":"46rem"} }
const _hoisted_15 = { class: "input-44-color flex-center" }
const _hoisted_16 = { class: "relative mr-12" }
const _hoisted_17 = { style: {"opacity":"0"} }
const _hoisted_18 = { class: "flex mt-32" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_loading = _resolveComponent("loading")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("myAccount.Company_Name")), 1),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        class: _normalizeClass(`input-44-0000000d ${
          _ctx.user.companyName ? 'validate-false' : 'validate-true'
        }`),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.companyName) = $event)),
        type: "text",
        placeholder: ""
      }, null, 2), [
        [_vModelText, _ctx.user.companyName]
      ]),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("myAccount.Logo")), 1),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_upload, {
        class: "avatar-uploader",
        action: "",
        "show-file-list": false,
        "http-request": _ctx.handleAvatarSuccess,
        "before-upload": _ctx.beforeAvatarUpload
      }, {
        default: _withCtx(() => [
          (_ctx.userDetail.imageFile)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.userDetail.imageFile,
                class: "avatar-uploaded"
              }, null, 8, _hoisted_6))
            : (_openBlock(), _createBlock(_component_el_icon, {
                key: 1,
                class: "avatar-uploader-icon"
              }))
        ]),
        _: 1
      }, 8, ["http-request", "before-upload"]),
      (_ctx.loadingImageFile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_loading)
          ]))
        : (!_ctx.userDetail.imageFile && !_ctx.companyLogoUrl)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("myAccount.Upload_Logo")), 1)
            ]))
          : (!_ctx.userDetail.imageFile && _ctx.companyLogoUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_ctx.companyLogoUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.companyLogoUrl,
                      class: "avatar-uploaded"
                    }, null, 8, _hoisted_12))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("myAccount.Brand_Color")), 1),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_el_color_picker, {
              modelValue: _ctx.color,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.color) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", {
            class: "mock-picker-color absolute-mid",
            style: _normalizeStyle(`background-color: ${_ctx.color}`)
          }, null, 4)
        ]),
        _createElementVNode("div", null, _toDisplayString(_ctx.color), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveMyCompany())),
        class: "btn btn-50 btn-primary",
        style: {"width":"11.4rem"}
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("btn.Save")), 1)
      ])
    ])
  ]))
}